import React from 'react';
import { LayoutDashboardIcon, ClipboardListIcon, TrendingUpIcon, FileTextIcon, CheckCircleIcon, BarChart3Icon, UsersIcon, ShieldIcon, ShieldHalfIcon, XIcon, MegaphoneIcon, ShieldAlertIcon, GlobeIcon } from 'lucide-react';
interface SidebarProps {
  activePage: string;
  onNavigate: (page: string) => void;
  isOpen?: boolean;
  onClose?: () => void;
}
export function Sidebar({
  activePage,
  onNavigate,
  isOpen = false,
  onClose
}: SidebarProps) {
  const menuItems = [{
    id: 'dashboard',
    label: 'Dashboard',
    icon: LayoutDashboardIcon
  }, {
    id: 'activities',
    label: 'Kegiatan',
    icon: ClipboardListIcon
  }, {
    id: 'progress',
    label: 'Progres',
    icon: TrendingUpIcon
  }, {
    id: 'documents',
    label: 'Dokumentasi',
    icon: FileTextIcon
  }, {
    id: 'verification',
    label: 'Verifikasi',
    icon: CheckCircleIcon
  }, {
    id: 'reports',
    label: 'Laporan',
    icon: BarChart3Icon
  }];
  const opsItems = [{
    id: 'pro',
    label: 'Operasi PRO',
    icon: MegaphoneIcon
  }, {
    id: 'kontra',
    label: 'Operasi KONTRA',
    icon: ShieldAlertIcon
  }, {
    id: 'osint',
    label: 'OSINT',
    icon: GlobeIcon
  }];
  const adminItems = [{
    id: 'users',
    label: 'Manajemen User',
    icon: UsersIcon
  }, {
    id: 'audit-log',
    label: 'Audit Log',
    icon: ShieldIcon
  }];
  return <div className={`w-64 bg-[#070A12] text-[#E2E8F0] h-screen fixed left-0 top-0 flex flex-col shadow-2xl z-40 border-r border-[#1E3A5F] glow-cyan transition-transform duration-300 ease-in-out ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`} data-id="element-47">
      {/* Logo Area */}
      <div className="p-6 relative overflow-hidden flex items-center justify-between" data-id="element-48">
        <div className="flex items-center space-x-3" data-id="element-49">
          <div className="absolute inset-0 cyber-grid opacity-20 pointer-events-none" data-id="element-50"></div>
          <div className="absolute inset-0 scanline opacity-30 pointer-events-none" data-id="element-51"></div>
          <ShieldHalfIcon className="w-8 h-8 text-[#00D4FF] relative z-10 glow-cyan-strong" data-id="element-52" />
          <div className="relative z-10" data-id="element-53">
            <h1 className="font-bold text-lg tracking-wide text-[#E2E8F0]" data-id="element-54">
              ROSS
            </h1>
            <p className="text-[10px] text-[#00D4FF] uppercase tracking-widest font-mono" data-id="element-55">
              RUANG OPERASI SIBER STRATEGIS
            </p>
          </div>
        </div>
        {onClose && <button onClick={onClose} className="lg:hidden text-[#94A3B8] hover:text-[#E2E8F0] relative z-10 p-1" data-id="element-56">
            <XIcon className="w-5 h-5" data-id="element-57" />
          </button>}
      </div>
      <div className="h-px bg-[#00D4FF]/30 w-full" data-id="element-58"></div>

      {/* Navigation */}
      <div className="flex-1 overflow-y-auto py-6 px-3 space-y-1" data-id="element-59">
        <div className="text-xs font-bold text-[#00D4FF]/60 uppercase tracking-widest mb-3 px-3" data-id="element-60">
          Menu Utama
        </div>
        {menuItems.map(item => {
        const Icon = item.icon;
        const isActive = activePage === item.id || activePage === 'activity-detail' && item.id === 'activities' || activePage === 'activity-form' && item.id === 'activities';
        return <button key={item.id} onClick={() => onNavigate(item.id)} className={`w-full flex items-center space-x-3 px-3 py-2.5 rounded transition-all duration-200 relative ${isActive ? 'bg-[#00D4FF]/10 text-[#00D4FF] border-l-2 border-[#00D4FF] font-semibold' : 'text-[#94A3B8] hover:bg-[#111827] hover:text-[#E2E8F0] border-l-2 border-transparent font-medium'}`} data-id="element-61">
              <Icon className="w-5 h-5" data-id="element-62" />
              <span data-id="element-63">{item.label}</span>
              {isActive && <span className="absolute right-3 w-1.5 h-1.5 rounded-full bg-[#00D4FF] glow-cyan-strong" data-id="element-64"></span>}
            </button>;
      })}

        <div className="mt-8 mb-4 px-3" data-id="element-65">
          <div className="h-px bg-[#1E3A5F] w-full" data-id="element-66"></div>
        </div>

        <div className="text-xs font-bold text-[#00D4FF]/60 uppercase tracking-widest mb-3 px-3 mt-4" data-id="element-67">
          Operasi Khusus
        </div>
        {opsItems.map(item => {
        const Icon = item.icon;
        const isActive = activePage === item.id;
        return <button key={item.id} onClick={() => onNavigate(item.id)} className={`w-full flex items-center space-x-3 px-3 py-2.5 rounded transition-all duration-200 relative ${isActive ? 'bg-[#00D4FF]/10 text-[#00D4FF] border-l-2 border-[#00D4FF] font-semibold' : 'text-[#94A3B8] hover:bg-[#111827] hover:text-[#E2E8F0] border-l-2 border-transparent font-medium'}`} data-id="element-68">
              <Icon className="w-5 h-5" data-id="element-69" />
              <span data-id="element-70">{item.label}</span>
              {isActive && <span className="absolute right-3 w-1.5 h-1.5 rounded-full bg-[#00D4FF] glow-cyan-strong" data-id="element-71"></span>}
            </button>;
      })}

        <div className="mt-8 mb-4 px-3" data-id="element-72">
          <div className="h-px bg-[#1E3A5F] w-full" data-id="element-73"></div>
        </div>

        <div className="text-xs font-bold text-[#00D4FF]/60 uppercase tracking-widest mb-3 px-3 mt-4" data-id="element-74">
          Administrator
        </div>
        {adminItems.map(item => {
        const Icon = item.icon;
        const isActive = activePage === item.id;
        return <button key={item.id} onClick={() => onNavigate(item.id)} className={`w-full flex items-center space-x-3 px-3 py-2.5 rounded transition-all duration-200 relative ${isActive ? 'bg-[#00D4FF]/10 text-[#00D4FF] border-l-2 border-[#00D4FF] font-semibold' : 'text-[#94A3B8] hover:bg-[#111827] hover:text-[#E2E8F0] border-l-2 border-transparent font-medium'}`} data-id="element-75">
              <Icon className="w-5 h-5" data-id="element-76" />
              <span data-id="element-77">{item.label}</span>
              {isActive && <span className="absolute right-3 w-1.5 h-1.5 rounded-full bg-[#00D4FF] glow-cyan-strong" data-id="element-78"></span>}
            </button>;
      })}
      </div>

      {/* Footer */}
      <div className="p-4 border-t border-[#1E3A5F] bg-[#070A12] relative overflow-hidden" data-id="element-79">
        <div className="absolute inset-0 scanline opacity-20 pointer-events-none" data-id="element-80"></div>
        <p className="text-xs text-center text-[#FF3B3B]/80 font-bold tracking-widest uppercase relative z-10" data-id="element-81">
          CLASSIFIED — INTERNAL USE ONLY
        </p>
        <p className="text-xs text-[#64748B] mt-1 text-center font-mono relative z-10" data-id="element-82">
          v1.0.0_SECURE
        </p>
      </div>
    </div>;
}